module.exports = __webpack_public_path__ + "img/发怒.203d1bec.gif";